export const eventTypeColors = {
    "bollywood dj night": "linear-gradient(95.58deg, #F97A33 12.18%, #E3BD36 86.93%)",
    "bollywood nights": "linear-gradient(95.58deg, #F97A33 12.18%, #E3BD36 86.93%)",
    "dj night": "linear-gradient(95.58deg, #F97A33 12.18%, #E3BD36 86.93%)",
    "comedy night": "linear-gradient(95.58deg, #338EF9 12.18%, #36D9E3 86.93%)",
    "live music": "linear-gradient(95.58deg, #73BF9B 12.18%, #4B6CB7 86.93%)",
    "ladies dj night": "linear-gradient(95.58deg, #73BF9B 12.18%, #4B6CB7 86.93%)",
    "quiz night": "linear-gradient(95.58deg, #134E5E 12.18%, #71B280 86.93%)",
    "special occasion": "linear-gradient(95.58deg, #F97A33 12.18%, #E3BD36 86.93%)",
    "open mic night": "linear-gradient(95.58deg, #8CA6DB 12.18%, #B993D6 86.93%)",
    "karaoke night": "linear-gradient(95.58deg, #649173 12.18%, #DBD5A4 86.93%)",
    "sports screening": "linear-gradient(95.58deg, #1D2B64 12.18%, #F8CDDA 86.93%)",
    "holi party": "linear-gradient(90.95deg, #F9A503 3.11%, #73B3FF 34.63%, #FF8787 64.66%, rgba(255, 20, 109, 0.75) 99.18%)",
};
export const tablePerksIcons = {
    "Private Waiter": "/icons/private-waiter.svg",
    "Valet Parking": "/icons/valet-parking.svg",
    "Party Guns": "/icons/party-guns.svg",
    "Bottle Service": "/icons/bottle-service.svg",
    "Customized Lighting": "/icons/customized-lighting.svg",
    "Exclusive Lounge Access": "/icons/exclusive-lounge.svg",
    "Personal DJ Shoutouts": "/icons/dj-shoutouts.svg",
    "Complimentary Champagne": "/icons/complimentary-champagne.svg",
    "Special Table Décor": "/icons/special-decor.svg",
    "Photo Booth Access": "/icons/photo-booth.svg",
    "Priority Entry": "/icons/priority-entry.svg",
    "VIP Wristbands": "/icons/vip-wristbands.svg",
    "Appetizer Platter": "/icons/appetizer-platter.svg",
    "Personalized Cake": "/icons/personalized-cake.svg",
    "Private Security": "/icons/private-security.svg",
    "Hookah Service": "/icons/hookah-service.svg",
    "Reserved Parking Spot": "/icons/reserved-parking.svg",
    "Table-side Mixologist": "/icons/mixologist.svg",
    "Customized Drink Menu": "/icons/custom-drink-menu.svg",
    "Private Dance Floor Access": "/icons/dance-floor.svg",
};
export const menuTypeTheme = {
    bbq: {
        primary: "#E86500",
        theme: "dark",
    },
    floral: {
        primary: "#4B678A",
        secondary: "#F3F6EE",
        theme: "light",
    },
    beach: {
        primary: "#00E8C9",
        theme: "dark",
    },
    rooftop: {
        primary: "#967d45",
        theme: "dark",
    },
    nonvegthali: {
        primary: "#7A0000",
        secondary: "#F2E4C9",
        theme: "light",
    },
    vegthali: {
        primary: "#7A0000",
        secondary: "#F2E4C9",
        theme: "light",
    },
    blossom: {
        primary: "#C05D71",
        theme: "light",
    },
    classic_light: {
        primary: "#0C5D56",
        theme: "light",
    },
    classic_dark: {
        primary: "#A6763B",
        theme: "dark",
    },
    finedine_normal: {
        primary: "#E86500",
        theme: "dark",
    },
    finedine_premium: {
        primary: "#E86500",
        theme: "dark",
    },
    cafe_normal: {
        primary: "#B9774C",
        secondary: "#F1E7D7",
        theme: "light",
    },
    cafe_premium: {
        primary: "#B9774C",
        theme: "dark",
    },
};
export const categoryLabel = {
    chefRecommend: "Chef's Recommended",
    specialItems: "Today's Special",
};
export const ThemisFoodCourtPubs = {
    600: {
        name: "Themis Greek House Murthal",
        image: "https://d1hddaam55e99y.cloudfront.net/pub_logos/600.png",
    },
    623: {
        name: "Themis Greek House BYOB",
        image: "https://d1hddaam55e99y.cloudfront.net/pub_logos/623.jpeg",
    },
    663: {
        name: "Athens Pizza",
        image: "https://d1hddaam55e99y.cloudfront.net/pub_logos/663.jpeg",
    },
    664: {
        name: "Dosa Plaza",
        image: "https://d1hddaam55e99y.cloudfront.net/pub_logos/664.jpeg",
    },
    665: {
        name: "Barista",
        image: "https://d1hddaam55e99y.cloudfront.net/pub_logos/665.jpeg",
    },
    666: {
        name: "Themis Street Food",
        image: "https://d1hddaam55e99y.cloudfront.net/pub_logos/666.png",
    },
};
export const VenueCountryCode = {
    "708": "1",
};
